import {useEffect, useState} from 'react'
import {
  NursesAssessmentForm1Fields,
  NURSES_ASSESSMENT_FORM1_INITIAL_STATE,
  NEW_NURSES_ASSESSMENT_FORM_INPUTS,
  NEW_NURSES_ASSESSMENT_INPUTS,
  NURSES_ASSESSMENT_FORM2_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM3_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM4_INITIAL_STATE,
  NursesAssessmentForm2Fields,
  NursesAssessmentForm3Fields,
  NursesAssessmentForm4Fields,
} from '../GENERAL_CONSTANTS'
import axios from 'axios'
import {Box, Typography, Button, Tabs, Tab, Paper,FormControl,Select,MenuItem,InputLabel,Grid} from '@mui/material'
import {toast} from 'react-toastify'
import {useHistory} from 'react-router-dom'
import {MoonLoader} from 'react-spinners'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {RootState} from '../../../../../setup'
import ConfirmationDialog from '../../../../reusable-components/Modals/ConfirmationDialog'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import NursesAssessmentform1 from './NursesAssessmentForms/NursesAssessmentForm1'
import NursesAssessmentForm2 from './NursesAssessmentForms/NursesAssessmentForm2'
import NursesAssessmentForm3 from './NursesAssessmentForms/NursesAssessmentForm3'
import NursesAssessmentForm4 from './NursesAssessmentForms/NursesAssessmentForm4'
import { useSelector } from 'react-redux'
import AssessmentTypeSelect from '../../../../reusable-components/AssesmentType/AssesmentType'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone
const selectAuth = (state: RootState) => state.auth

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nurses-assessment-tabpanel-${index}`}
      aria-labelledby={`nurses-assessment-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `nurses-assessment-tab-${index}`,
    'aria-controls': `nurses-assessment-tabpanel-${index}`,
  }
}

export default function NewNursesAssessmentNote() {
  const history = useHistory()
  const [formElements, setFormElements] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const [isMobile, setIsMobile] = useState(false)


  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 900)
    }
    
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])



  useEffect(() => {
    setFormElements(NEW_NURSES_ASSESSMENT_INPUTS)
  }, [])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  const [isFormLoading, setIsFormLoading] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [pendingFormData, setPendingFormData] = useState(null)
  const [existingNoteData, setExistingNoteData] = useState(null)
  const [formData, setFormData] = useState(NEW_NURSES_ASSESSMENT_FORM_INPUTS)
  const [form1Data, setForm1Data] = useState<NursesAssessmentForm1Fields>(
    NURSES_ASSESSMENT_FORM1_INITIAL_STATE
  )
  const [form2Data, setForm2Data] = useState<NursesAssessmentForm2Fields>(
    NURSES_ASSESSMENT_FORM2_INITIAL_STATE
  )
  const [form3Data, setForm3Data] = useState<NursesAssessmentForm3Fields>(
    NURSES_ASSESSMENT_FORM3_INITIAL_STATE
  )
  const [form4Data, setForm4Data] = useState<NursesAssessmentForm4Fields>(
    NURSES_ASSESSMENT_FORM4_INITIAL_STATE
  )
  const [noteData, setNoteData] = useState({
    noteType: '',
    assessmentType: '',
  })
  const authUser = useSelector(selectAuth)
  const handleSubmitForm = async (formData) => {
    await checkExistingNote(formData)
  }

  const checkExistingNote = async (formValues) => {
    try {
      const response = await axios.post('/nursesAssessment/checkExisting', {
        clientId: form1Data['clientId'],
        noteType: noteData['noteType'],
      })
      const {exists, existingTherapy} = response.data

      if (exists) {
        setExistingNoteData(existingTherapy)
        setPendingFormData(formValues)
        setShowConfirmationModal(true)
      } else {
        await submitNote(formValues)
      }
    } catch (error) {
      console.error('Error checking existing note:', error)
      toast.error('Error checking for existing notes. Please try again.')
    }
  }

  const submitNote = async (formValues) => {
    setIsFormLoading(true)
    try {
      const payload = {
        clientId: form1Data.clientId,
        createdBy: authUser.user._id,
        noteType: noteData.noteType,
         assessmentType: noteData.assessmentType,
        generalInformation: {
          assessmentDate: form1Data.assessmentDate,
          allergies: Array.isArray(form1Data.allergies) ? [...form1Data.allergies] : [],
          otherAllergies: form1Data.otherAllergies,
          codeStatus: form1Data.codeStatus,
          infoSource: form1Data.infoSource,
          otherInfoSource: form1Data.otherInfoSource,
          precautions: form1Data.precautions,
          otherPrecautions: form1Data.otherPrecautions,
          vitalSigns: {
            t: form1Data.t || '',
            r: form1Data.r || '',
            p: form1Data.p || '',
            bp: form1Data.bp || '',
            height: form1Data.height || '',
            weight: form1Data.weight || ''
          },
        },
        medications: Array.isArray(form1Data.medications) ? [...form1Data.medications] : [],
        dietaryScreen: {
          wounds: form1Data.wounds,
          alternativeNutrition: form1Data.alternativeNutrition,
          weightdetails: form1Data.weightdetails,
          weightamount: form1Data.weightamount,
          dietaryDetails: Array.isArray(form1Data.dietaryDetails)
            ? [...form1Data.dietaryDetails]
            : [],
        },
        psychosicial: {
          leisureInterest: form2Data.leisureInterest || [],
          socialActivities: form2Data.socialActivities || '',
          copingSkills: form2Data.copingSkills || '',
          culturalPractices: form2Data.culturalPractices || '',
          spiritualPractices: form2Data.spiritualPractices || '',
          otherPsychosocial: form2Data.otherPsychosocial || '',
          abuseHistory: form2Data.abuseHistory || '',
          selfHarm: form2Data.selfHarm || '',
          etohConsumption: form2Data.etohConsumption || '',
          drugAbuse: form2Data.drugAbuse || '',
          caffeineIntake: form2Data.caffeineIntake || '',
          tobaccoUse: form2Data.tobaccoUse || '',
          cessationEducation: form2Data.cessationEducation || '',
        },
        medicalDetails: {
          medicalHistory: form2Data.medicalHistory || [],
          lastFluVaccine: form2Data.lastFluVaccine || '',
          lastPneumoniaVaccine: form2Data.lastPneumoniaVaccine || '',
          prevSurgeries: form2Data.prevSurgeries || '',
          patientTB: form2Data.patientTB || '',
          familyTB: form2Data.familyTB || '',
          followingSymptoms: form2Data.followingSymptoms || '',
          bloodTransfusion: form2Data.bloodTransfusion || '',
          transfusionReactionDetails: form2Data.transfusionReactionDetails || '',
          diabetic: form2Data.diabetic || '',
          diabeticYears: form2Data.diabeticYears || '',
          diabeticTreatment: form2Data.diabeticTreatment || '',
          glucometer: form2Data.glucometer || '',
          fingerStick: form2Data.fingerStick || '',
          administerInsulin: form2Data.administerInsulin || '',
          interpreterNeeded: form2Data.interpreterNeeded || '',
          preferredLanguage: form2Data.preferredLanguage || '',
          familyCareInvolved: form2Data.familyCareInvolved || '',
          familyAvailforTeaching: form2Data.familyAvailforTeaching || '',
          educationalNeeds: form2Data.educationalNeeds || '',
          prevSurgeriesDetails: form2Data.prevSurgeriesDetails || '',
        },
        neurologic: {
          response: form2Data.response || '',
          motorResponse: form2Data.motorResponse || '',
          verbalResponse: form2Data.verbalResponse || '',
          affect: form2Data.affect || '',
          otherAffect: form2Data.otherAffect || '',
          hearing: form2Data.hearing || '',
          vision: form2Data.vision || '',
          gagReflex: form2Data.gagReflex || '',
          speech: form2Data.speech || '',
        },
        // NursesAssessmentForm3
        cardiovascular: {
          regular: form3Data.regular || [],
          irregular: form3Data.irregular || [],
          strong: form3Data.strong || [],
          weak: form3Data.weak || [],
          chestPain: form3Data.chestPain || '',
          chestPainLoc: form3Data.chestPainLoc || '',
          nailBeds: form3Data.nailBeds || '',
          edemafour: form3Data.edemafour || [],
          edemafourDetails: form3Data.edemafourDetails || '',
          edemathree: form3Data.edemathree || [],
          edemathreeDetails: form3Data.edemathreeDetails || '',
          edematwo: form3Data.edematwo || [],
          edematwoDetails: form3Data.edematwoDetails || '',
          edemaone: form3Data.edemaone || [],
          edemaoneDetails: form3Data.edemaoneDetails || '',
          otherCardiovascular: form3Data.otherCardiovascular || [],
          cardianRhythmDetails: form3Data.cardianRhythmDetails || '',
          edemanone: form3Data.edemanone || '',
          capillaryRefillOtherDetails: form3Data.capillaryRefillOtherDetails || '',
          capillaryRefillTime: form3Data.capillaryRefillTime || '',
        },
        pulmonary: {
          clear: form3Data.clear || [],
          equalbilaterally: form3Data.equalbilaterally || [],
          course: form3Data.course || [],
          rales: form3Data.rales || [],
          rhonchi: form3Data.rhonchi || [],
          wheeze: form3Data.wheeze || [],
          pleural: form3Data.pleural || [],
          otherSoundDetails: form3Data.otherSoundDetails || '',
          cough: form3Data.cough || '',
          coughColor: form3Data.coughColor || '',
          coughQuality: form3Data.coughQuality || '',
          coughQuantity: form3Data.coughQuantity || '',
          nasalFlaring: form3Data.nasalFlaring || '',
          ett: form3Data.ett || '',
          o2: form3Data.o2 || '',
          breathShortness: form3Data.breathShortness || '',
          ettSize: form3Data.ettSize || '',
          o2Amount: form3Data.o2Amount || '',
          o2TakenVia: form3Data.o2TakenVia || '',
        },
        // NursesAssessmentForm4
        gastroIntestinal: {
          lastBMdate: form4Data.lastBMdate || '',
          bowelPatterns: form4Data.bowelPatterns || '',
          bowelSounds: form4Data.bowelSounds || '',
          abdomen: form4Data.abdomen || '',
          abdomenLocation: form4Data.abdomenLocation || '',
        },
        genitourinary: {
          experiencingGI: form4Data.experiencingGI || '',
          urineColor: form4Data.urineColor || '',
          bladder: form4Data.bladder || '',
          catheterType: form4Data.catheterType || '',
          catheterSize: form4Data.catheterSize || '',
          catheterDate: form4Data.catheterDate || '',
          catheterChange: form4Data.catheterChange || '',
        },
        musculoskeletal: {
          muscleStrength: {
            muscleEqual: form4Data.equal || [],
            muscleStrong: form4Data.strong || [],
            muscleWeak: form4Data.weak || [],
            paralysis: form4Data.paralysis || [],
            spastic: form4Data.spastic || [],
            contracture: form4Data.contracture || [],
            flaccid: form4Data.flaccid || [],
            amputation: form4Data.amputation || [],
          },
          physicalImpaired: {
            bedMobility: form4Data.bedMobility || false,
            transfers: form4Data.transfers || false,
            gait: form4Data.gait || false,
            balance: form4Data.balance || false,
          },
          communicationFunction: {
            comprehension: form4Data.comprehension || false,
            expression: form4Data.expression || false,
            cognition: form4Data.cognition || false,
            readingWriting: form4Data.readingWriting || false,
          },
          adlFunction: {
            grooming: form4Data.grooming || false,
            feeding: form4Data.feeding || false,
            bathing: form4Data.bathing || false,
            dressing: form4Data.dressing || false,
          },
          assistiveDevices: form4Data.assistiveDevices || [],
          otherassistiveDevices: form4Data.otherassistiveDevices || '',
        },
        skinAssessment: {
          skinColor: form4Data.skinColor || [],
          otherskinDetails: form4Data.otherskinDetails || '',
          otherskinTempDetails: form4Data.otherskinTempDetails || '',
          otherTurgorDetails: form4Data.otherTurgorDetails || '',
          otherskinTextureDetails: form4Data.otherskinTextureDetails || '',
          bradenScale: {
            sensory: form4Data.sensory || '',
            moisture: form4Data.moisture || '',
            activity: form4Data.activity || '',
            mobility: form4Data.mobility || '',
            nutrition: form4Data.nutrition || '',
            friction: form4Data.friction || '',
          },
          skinPrecatuions: form4Data.skinPrecatuions || false,
          woundTeamNotified: form4Data.woundTeamNotified || false,
        },
        nutrition: {
          dietType: form4Data.dietType || '',
          supplements: form4Data.supplements || '',
          howOften: form4Data.howOften || '',
          restricitons: form4Data.restricitons || '',
          parentalFeeding: form4Data.parentalFeeding || '',
          experiencing: form4Data.experiencing || [],
          mucosaIntact: form4Data.mucosaIntact || false,
          tongueIntact: form4Data.tongueIntact || false,
          dentitionIntact: form4Data.dentitionIntact || false,
          otherdetails: form4Data.otherdetails || '',
        },
        painAsessment: Array.isArray(formData.painAsessment) ? [...formData.painAsessment] : [],
        painScale: formData.painScale,
        fallRisk: {
          fallWithinYear: formData.fallWithinYear || '',
          currentlyonFallPrecaution: formData.currentlyonFallPrecaution || '',
        },
        vascularAcess: Array.isArray(formData.vascularAcess) ? [...formData.vascularAcess] : [],
      }

      const res = await axios.post('/nursesAssessment/createOrUpdate', payload)

      const {message, success} = res?.data
      if (!success) {
        return toast.error(message)
      }

      if (res?.data?.status === 200) {
        toast.success('Nurses Assessment updated successfully')
      } else if (res?.data?.status === 201) {
        toast.success('Nurses Assessment created successfully')
      } else {
        toast.success(message)
      }

      history.push('/notes/nurses-notes/list')
    } catch (e) {
      toast.error(e?.response?.data?.error || `Couldn't Add Note`)
      console.error('Error adding note:', e)
    } finally {
      setIsFormLoading(false)
    }
  }

  const handleConfirmSubmit = async () => {
    setShowConfirmationModal(false)
    if (pendingFormData) {
      await submitNote(pendingFormData)
    }
  }
  const handleCancelSubmit = () => {
    setShowConfirmationModal(false)
    setPendingFormData(null)
    setExistingNoteData(null)
  }

  const handleSaveAll = () => {
    // Combine all form data and submit
    const combinedFormData = {
      ...formData,
      form1Data,
      form2Data,
      form3Data,
      form4Data,
    }
    handleSubmitForm(combinedFormData)
  }

  const handleNext = () => {
    if (activeTab < 4) {
      setActiveTab(activeTab + 1)
    }
  }

  const handlePrevious = () => {
    if (activeTab > 0) {
      setActiveTab(activeTab - 1)
    }
  }

  return (
    <FormWrapper
      title='Nursing Assessment'
      content={
        <>
          <Typography
            sx={{ fontSize: '16px', fontWeight: 'bold', mb: '0.5rem', ml: '1rem' }}
            color="primary"
          >
            Note Type
          </Typography>

 <Box sx={{ px: 2, mb: 2 }}>
  <Grid container spacing={2} alignItems="center">
    <Grid item xs={12} sm={6}>
      <FrequencyDateRangePicker
        isEntry={false}
        isTemplate={true}
        isFullForm={false}
        isEdit={false}
        formData={noteData}
        setFormData={setNoteData}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
              <AssessmentTypeSelect
                value={noteData.assessmentType || ''}
                onChange={(value) =>
                  setNoteData((prev) => ({ 
                    ...prev, 
                    assessmentType: value 
                  }))
                }
              />
            </Grid>
      </Grid>
    </Box>
          {isFormLoading ? (
            <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
              <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
            </div>
          ) : (
            <>
              <Box sx={{ width: '100%', mt: 2, }}>
                                 <Paper elevation={1} sx={{ mb: 2, ml:2, mr:2, borderRadius: '0px', position: 'relative' }}>
                  <Box sx={{ 
                    overflowX: 'auto',
                    '&::-webkit-scrollbar': {
                      height: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#c1c1c1',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#a8a8a8',
                    },
                  }}>
                                         <Tabs 
                       value={activeTab} 
                       onChange={handleTabChange} 
                       aria-label="nurses assessment tabs"
                       variant={isMobile ? "scrollable" : "fullWidth"}
                       scrollButtons={false}
                       allowScrollButtonsMobile={false}

                       sx={{
                         '& .MuiTab-root': {
                           minHeight: '48px',
                           fontSize: '14px',
                           fontWeight: 500,
                           textTransform: 'none',
                           ...(isMobile && {
                             minWidth: 'auto',
                             padding: '12px 16px',
                             whiteSpace: 'nowrap',
                           }),
                           '@media (max-width: 600px)': {
                             fontSize: '12px',
                             padding: '8px 12px',
                             minHeight: '40px',
                           },
                         },
                         '& .Mui-selected': {
                           color: '#1976d2',
                         },
                         '& .MuiTabs-indicator': {
                           backgroundColor: '#1976d2',
                         },
                       }}
                     >
                                             <Tab label="General Information" {...a11yProps(0)} />
                       <Tab label="Psychosocial & Medical" {...a11yProps(1)} />
                       <Tab label="Cardiovascular & Pulmonary" {...a11yProps(2)} />
                       <Tab label="GI, GU & Musculoskeletal" {...a11yProps(3)} />
                       <Tab label="Additional Information" {...a11yProps(4)} />
                     </Tabs>
                     

                  </Box>
                </Paper>

                <TabPanel value={activeTab} index={0}>
                  <NursesAssessmentform1
                    data={form1Data}
                    setFormValues={setForm1Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={1}>
                  <NursesAssessmentForm2
                    data={form2Data}
                    setFormValues={setForm2Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={2}>
                  <NursesAssessmentForm3
                    data={form3Data}
                    setFormValues={setForm3Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={3}>
                  <NursesAssessmentForm4
                    data={form4Data}
                    setFormValues={setForm4Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={4}>
                  <DynamicForm
                    fields={formElements}
                    data={formData}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                    setFormValues={setFormData}
                  />
                </TabPanel>
              </Box>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: { xs: 'stretch', sm: 'space-between' }, 
          gap: { xs: 2, sm: 2 }, 
          mt: 3, 
          p: { xs: 1, sm: 2 }
        }}>               
            
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 1.5, sm: 2 },
            flexDirection: { xs: 'column', sm: 'row' },
            order: { xs: 2, sm: 2 },
            mr: 1.5
          }}>
            <Button
              variant="contained"
              onClick={handleSaveAll}
              disabled={isFormLoading}
              fullWidth={isMobile}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 }
              }}
            >
              {isFormLoading ? 'Saving...' : 'Save'}
            </Button>
            <Button
              variant="outlined"
              onClick={() => history.push('/notes/nurses-notes/list')}
              fullWidth={isMobile}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 }
              }}
            >
              Cancel
            </Button>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 1.5, sm: 2 },
            flexDirection: { xs: 'row', sm: 'row' },
            order: { xs: 1, sm: 1 },
            mr: 1.5
          }}>
            <Button
              variant="outlined"
              onClick={handlePrevious}
              disabled={activeTab === 0}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 },
                flex: { xs: '1 1 50%', sm: '1 1 auto' }
              }}
            >
              Previous
            </Button>
            <Button
              variant="outlined"
              onClick={handleNext}
              disabled={activeTab === 4}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 },
                flex: { xs: '1 1 50%', sm: '1 1 auto' }
              }}
            >
              Next
            </Button>
          </Box>
        </Box>
            </>
          )}
          <ConfirmationDialog
            open={showConfirmationModal}
            onClose={handleCancelSubmit}
            onConfirm={handleConfirmSubmit}
            title='Note Already Exists'
            message='A Nurses Assessment note with this Client and Note Type already exists.'
            confirmText='Replace Note'
            cancelText='Cancel'
            severity='warning'
            showDetails={!!existingNoteData}
            detailsData={
              existingNoteData
                ? {
                    title: 'Existing Note Details',
                    fields: [
                      {
                        label: 'Client',
                        value: existingNoteData?.clientName?.toUpperCase(),
                      },
                      {
                        label: 'Note Type',
                        value: existingNoteData?.noteType,
                      },
                    ],
                  }
                : undefined
            }
            warningMessage='Are you sure you want to proceed with creating a new note? It will replace the existing note.'
          />
        </>
      }
    />
  )
}
